module.exports = __webpack_public_path__ + "img/4-4.88e17af.png";